import React from 'react';
import {Main} from '../../layouts';
import Container from '../../components/Container';
import {List, ListItemText, Typography} from '@mui/material';

const TermsView = () => {
    return (
        <Main>
            <Container>

                {/*start*/}
                <Typography variant="h4">Terms Of Use</Typography>
                <br/>
                <Typography variant="body2">
                    Vampire Labs, LLC (Vampire Labs) maintains this site (the “Site”) for your use, merchandise
                    purchase, information, education and communication. Please feel free to browse the Site. You may
                    download material displayed on the Site for use as indicated on the Site provided you also retain
                    all copyright and other proprietary notices contained on the materials. You may not, however,
                    distribute, modify, transmit, reuse, repost, or use the content of the Site for public or commercial
                    purposes, including the text, images, audio and video without the express written permission of
                    Vampire Labs. Your access to and use of the Site is also subject to the following terms and
                    conditions (“Terms and Conditions”) and all applicable laws. By accessing and browsing the Site, you
                    accept, without limitation or qualifications, the Terms and Conditions.
                </Typography>
                <br/>
                <Typography variant="h4">Terms And Conditions</Typography>
                <br/>
                <ol>
                    <li>
                        <Typography variant="body2">
                            All materials contained on the Site are protected by United States copyright law and may not
                            be reproduced, distributed, transmitted, displayed, published or broadcast without the prior
                            written permission of Vampire Labs except as provided in these Terms and Conditions or as
                            provided in the text on the Site. You may not alter or remove any copyright, trademark or
                            other notice from copies of the Site’s content. Vampire Labs neither warrants nor represents
                            that your use of materials displayed on the Site will not infringe rights of third parties
                            not owned by or affiliated with Vampire Labs.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            While Vampire Labs uses reasonable efforts to include accurate and up to date content in the
                            Site, Vampire Labs makes no warranties or representations as to its accuracy. Vampire Labs
                            assumes no liability or responsibility for any errors or omissions in the content of the
                            Site.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Your use of the Site is at your risk. Neither Vampire Labs nor any other party involved in
                            creating, producing, or delivering the Site is liable for any direct, incidental,
                            consequential, indirect or punitive damages arising out of your access to, or use of, the
                            Site. Without limiting the foregoing, everything on the Site is provided to you "AS
                            AVAILABLE" AND "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING,
                            BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                            PURPOSE OR NON-INFRINGEMENT. Please note that some jurisdictions may not allow the exclusion
                            of implied warranties, so some of the above exclusions may not apply to you. Check your
                            local laws for any restrictions or limitations regarding the exclusion of implied
                            warranties. Vampire Labs also assumes no responsibility, and shall not be liable for, any
                            damages to, or viruses that may infect, your computer equipment or other property on account
                            to, use of, or browsing in the Site or your downloading of any materials, data, text,
                            images, video or audio from the Site.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Pricing, Specifications and Availability. All prices are in United States Dollars. Prices,
                            specifications and availability of products are subject to change without notice. Due to the
                            changing nature of the electronics market, and because of the technical differences in the
                            equipment of our customers, product descriptions may not reflect current technical
                            information, and we cannot be responsible for photographic differences in product size,
                            shape and color. <a href="http://vampirelabs.com">vampirelabs.com</a> orders generate an
                            automatic confirmation e-mail, but the receipt of a confirmation only means that we have
                            received your order, and does not constitute an offer to sell. We may change our pricing,
                            product description or specifications after any confirmation e-mail, but prior to shipment,
                            due to errors, changing market conditions, product discontinuation or unavailability,
                            typographical errors, or any other reason. We reserve the right to limit the quantity of any
                            item sold, or prohibit a sale altogether. We will notify you of any corrections or changes
                            to your order, and will not complete it until we have your approval. We estimate your order
                            will ship within two business days. Published prices do not include shipping, sales tax and
                            insurance. We are required by law to collect sales tax on all shipments to all states except
                            Alaska, Delaware, Hawaii, Montana, New Hampshire, Oregon, Virginia, and the District of
                            Columbia (at the state/local tax rate).
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Payment and Shipping Information. You may pay by credit card or any other form of electronic
                            payment allowable by Vampire Labs, at its sole discretion.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Shipping. Vampire Labs will ship to addresses within the 50 United States, the District of
                            Columbia and Canada by Fedex or United States Postal Service. International shipping will be
                            at Vampire Labs’ sole discretion and additional shipping and handling fees may apply. We are
                            not responsible for lost or damaged packages. Fedex charges may include prepaid insurance up
                            to the limits specified by Fedex. If your package is sent by Fedex and is lost or damaged,
                            you may contact Fedex. All shipments addressed to P.O. boxes will be shipped via USPS,
                            therefore Vampire Labs cannot guarantee delivery times when shipping to a P.O. Box. Shipment
                            tracking is not available for orders being shipped to P.O. Boxes. Vampire Labs reserves the
                            right, at its sole discretion, to cancel any orders submitted for shipment to a freight
                            forwarder or similar entity.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Product Warranty and Limitations. Warranty: WE WARRANT THAT VAMPIRE LABS-BRANDED PRODUCTS
                            WILL BE FREE FROM MATERIAL DEFECTS IN MATERIALS AND WORKMANSHIP DURING THE LIMITED WARRANTY
                            PERIOD, OF WHICH THE LIMITED WARRANTY PERIOD SHALL EXPIRE 30 DAYS FROM THE PRODUCTS’ SHIP
                            DATE.. WE MAKE NO OTHER WARRANTY, EXPRESS OR IMPLIED, AND ANY IMPLIED WARRANTY OF
                            MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE WHICH EXCEEDS THE FOREGOING WARRANTY IS
                            HEREBY DISCLAIMED.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Limitation Of Liability. IN NO EVENT SHALL VAMPIRE LABS, ITS SUBSIDIARIES OR AFFILIATES, OR
                            THEIR RESPECTIVE PARTNERS, OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS, REPRESENTATIVES OR
                            AGENTS (COLLECTIVELY, “Vampire Labs”) BE LIABLE FOR DIRECT, SPECIAL, INCIDENTAL,
                            CONSEQUENTIAL, PUNITIVE, OR INDIRECT DAMAGES (INCLUDING BUT NOT LIMITED TO, LOSS OF DATA,
                            USE OR PROFITS), HOWEVER CAUSED, WHETHER FOR BREACH OF CONTRACT, NEGLIGENCE, OR OTHERWISE,
                            AND WHETHER OR NOT VAMPIRE LABS HAS BEEN ADVISED OF THE POSSIBILITY OF ANY SUCH DAMAGES. YOU
                            AGREE THAT VAMPIRE LABS’ MAXIMUM LIABILITY ARISING FROM ANY PRODUCT SOLD BY VAMPIRE LABS
                            SHALL NOT EXCEED THE PRICE OF SUCH PRODUCT. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION
                            OF EXCLUSION OF LIABILITY FOR CERTAIN DAMAGES, SO THE ABOVE MAY NOT APPLY TO YOU TO THE
                            EXTENT SUCH JURISDICTION’S LAW IS APPLICABLE TO THIS AGREEMENT.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Return Policy. Vampire Labs is happy to rectify defective items for replacement or refund
                            for thirty (30) days after the Limited Warranty Period. If you are returning a defective
                            item, please contact Customer Support at <a
                            href="mailto:services@vampirelabs.com">services@vampirelabs.com</a>. Returns Procedure. All
                            returned items must be shipped prepaid to Vampire Labs and must be accompanied with a
                            Vampire Labs Return Authorization Number (RMA), please contact Customer Support at <a
                            href="mailto:services@vampirelabs.com">services@vampirelabs.com</a> to obtain a Return
                            Authorization (RMA) number. In order to get an RMA number to formally process your return,
                            you must provide the following information:
                            <br/>
                            <ul>
                                <li>Copy of Invoice or Email Invoice</li>
                                <li>Order Number</li>
                                <li>Date of original purchase</li>
                                <li>Reason for request for RMA</li>
                                <li>Your e-mail address</li>
                            </ul>
                            Please note that Vampire Labs charges a 25% restocking fee on all returned items, and is
                            unable to accept any returns without an RMA number.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Any communication or material you transmit to the Site by electronic mail or otherwise,
                            including any data, questions, comments, suggestions or the like is, and will be treated as,
                            non-confidential and non-proprietary. Vampire Labs or its affiliates may use anything you
                            transmit or post for any purpose, including but not limited to, reproduction, disclosure,
                            transmission, publication, broadcast and posting. Furthermore, Vampire Labs is free to use
                            any ideas, concepts know-how or techniques contained in any communication you send to the
                            Site for any purpose whatsoever including, but not limited to, developing, manufacturing and
                            marketing products using such information.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            A valid identification name (ID) and password may be required to gain access to the Site or
                            portions of the Site. Vampire Labs may assign and ID and password to you in its sole
                            discretion. You may not use the ID assigned to another user, with the intent to impersonate
                            that user or use an ID assigned to another user without that user’s prior authentication.
                            You shall immediately notify Vampire Labs of any known or suspected un-authorization use of
                            IDs and passwords, or any known or suspected breach of Site security including loss, theft
                            or un-authorized disclosure of your ID and password. Vampire Labs may, in its sole
                            discretion, terminate or suspend your access to all or part of the site for any reason,
                            including, without limitation, your breach of these Terms and Conditions.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Images displayed on the Site are either the property of, or used with permission by, Vampire
                            Labs. The use of these images by you, or anyone else authorized by you, is prohibited unless
                            specifically permitted by these Terms and Conditions or specific permission provided
                            elsewhere on the Site. Any unauthorized use of the images may violate copyright laws,
                            trademark laws, the laws of privacy and publicity and communications regulations and
                            statutes.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            The trademarks, logos and service marks (collectively the “Trademarks”) displayed on the
                            Site, including Vampire Labs<sup>TM</sup>, Vampire Proof<sup>TM</sup>, the Vampire Labs
                            logo, and others, are registered and unregistered Trademarks of Vampire Labs. Other
                            trademarks, logos and service marks may be registered and unregistered Trademarks of third
                            parties. Nothing contained on the Site should be construed as granting, by implication,
                            estoppel, or otherwise, any license or right to use any Trademark displayed on the Site
                            without the written permission of Vampire Labs or such third party that may own the
                            Trademarks displayed on the Site. Your misuse of the Trademarks displayed on the Site, or
                            any other content on the Site, except as provided in these Terms and Conditions, is strictly
                            prohibited. You are also advised that Vampire Labs will aggressively enforce its
                            intellectual property rights to the fullest extent of the law, including the seeking of
                            criminal prosecution.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Vampire Labs has not reviewed all of the sites linked to the Site and is not responsible for
                            the content of any off-site pages or any other sites linked to the Site. Your linking to any
                            other off-site pages or other sites is at your own risk.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Although Vampire Labs may from time to time monitor or review discussions, chats, postings,
                            transmissions, bulletin boards, and the like on the Site, Vampire Labs is under no
                            obligation to do so and assumes no responsibility or liability arising from the content of
                            any such locations nor for any error, defamation, libel, slander, omission, falsehood,
                            obscenity, pornography, profanity, danger or inaccuracy contained in any information within
                            such locations on the Site. You are prohibited from posting or transmitting any unlawful,
                            threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic or
                            profane material or any material that could constitute or encourage conduct that would be
                            considered a criminal offense, give rise to civil liability or otherwise violate any law.
                            Vampire Labs will fully cooperate with any law enforcement authorities or court order
                            requesting or directing Vampire Labs to disclose the identity of anyone posting any such
                            information or materials.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            Vampire Labs may at any time revise these Terms and Conditions by updating this posting. You
                            are bound by any such revisions and should therefore periodically visit this page to review
                            the then current Terms and Conditions to which you are bound.
                        </Typography>
                    </li>
                    <br/>
                    <li>
                        <Typography variant="body2">
                            These Terms and Conditions have been made in and shall be construed and enforced in
                            accordance with the laws of the State of Texas without regard to conflicts of law
                            principles. Any action with regard to these Terms and Conditions will be brought in the
                            federal or state courts located in Texas.
                        </Typography>
                    </li>
                </ol>
            </Container>
        </Main>
    );
};

export default TermsView;